/**
 * @group Constants
 * @internal
 *
 * @summary
 * <blockquote>Validation error messages for event validation functions</blockquote>
 *
 * @example
 * ```typescript
 * import { VALIDATION_MESSAGES } from '@shared/reporting';
 *
 * console.error(VALIDATION_MESSAGES.CONSOLE_VALIDATION_FAILED); // 'Console event validation failed'
 * ```
 */
export const VALIDATION_MESSAGES = {
  BASE_EVENT_VALIDATION_FAILED: 'Base event validation failed',
  BASE_EVENT_VALIDATION_FAILED_DETAILS: 'Failed to validate base event structure'
} as const;
